exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._chasing-dots__chasing-dots__uvt67 {\n  margin: auto;\n  position: relative;\n  text-align: center;\n  animation: _chasing-dots__sk-chasingDotsRotate__336ok 2s infinite linear; }\n  ._chasing-dots__chasing-dots__uvt67 ._chasing-dots__child__2Ssfj {\n    width: 60%;\n    height: 60%;\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    border-radius: 100%;\n    animation: _chasing-dots__sk-chasingDotsBounce__2pQIr 2s infinite ease-in-out; }\n  ._chasing-dots__chasing-dots__uvt67 ._chasing-dots__dot2__bkeep {\n    top: auto;\n    bottom: 0;\n    animation-delay: -1s; }\n\n@keyframes _chasing-dots__sk-chasingDotsRotate__336ok {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes _chasing-dots__sk-chasingDotsBounce__2pQIr {\n  0%, 100% {\n    transform: scale(0); }\n  50% {\n    transform: scale(1); } }\n", ""]);

// exports
exports.locals = {
	"chasing-dots": "_chasing-dots__chasing-dots__uvt67",
	"sk-chasingDotsRotate": "_chasing-dots__sk-chasingDotsRotate__336ok",
	"child": "_chasing-dots__child__2Ssfj",
	"sk-chasingDotsBounce": "_chasing-dots__sk-chasingDotsBounce__2pQIr",
	"dot2": "_chasing-dots__dot2__bkeep"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/spin/_chasing-dots.scss
// module id = 412
// module chunks = 0 1